export default __webpack_public_path__ + "static/media/webcam14.a3df411f.jfif";